import { ComponentsProps, ComponentsVariants, Theme } from "@mui/material";
import { ComponentsOverrides } from "@mui/material/styles/overrides";

type MuiProgressOverrides = {
  defaultProps?: ComponentsProps['MuiCircularProgress'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiCircularProgress'];
  variants?: ComponentsVariants['MuiCircularProgress'];
}

function getMuiCircularProgressOverride(): MuiProgressOverrides {
  return {
    styleOverrides: {
      colorPrimary: {
        color: "var(--cir-progress-clr-primary)"
      }
    }
  }
}

export default getMuiCircularProgressOverride;